import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { enrichAxiosErrorEvent } from "@/lib/utils/sentry";

import "./index.css";

// Import the generated route tree
import { App } from "./App.tsx";

const enabledSentryStages: Array<ImportMetaEnv["VITE_API_STAGE"]> = [
  "main",
  "stage",
];

const apiStage = import.meta.env.VITE_API_STAGE;
const hostname = window.location.hostname;
const isLocalHost =
  hostname === "localhost" ||
  hostname.endsWith(".localhost") ||
  hostname.startsWith("127.") ||
  hostname === "0.0.0.0" ||
  hostname === "[::1]" ||
  hostname === "::1";

if (
  !import.meta.env.DEV &&
  !isLocalHost &&
  enabledSentryStages.includes(apiStage)
) {
  Sentry.init({
    dsn: "https://f6065cfb77a302173c3efb24da7fb37a@o4511888893083648.ingest.us.sentry.io/4511888916021248",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      // Feedback button temporarily disabled.
      // Sentry.feedbackIntegration({
      //   autoInject: true,
      //   triggerLabel: "",
      //   triggerAriaLabel: "Feedback",
      // }),
    ],
    environment: apiStage,
    beforeSend: enrichAxiosErrorEvent,
    // Tracing
    tracesSampleRate: apiStage === "main" ? 1.0 : 0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: apiStage === "main" ? 0.1 : 0,
    replaysOnErrorSampleRate: apiStage === "main" ? 1.0 : 0,
  });
}

// Render the app
const rootElement = document.getElementById("root") as Element;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
